import { render, staticRenderFns } from "./ActionsCostsEmpty.vue?vue&type=template&id=22fc31cc&"
import script from "./ActionsCostsEmpty.vue?vue&type=script&lang=js&"
export * from "./ActionsCostsEmpty.vue?vue&type=script&lang=js&"
import style0 from "./ActionsCostsEmpty.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VFlex,VLayout,VSelect})
